// extracted by mini-css-extract-plugin
module.exports = {"dashboard-container":"style_dashboard-container__1EhpU"};